<template>
	<v-container fill-height>
		<!-- <v-row justify="center" align="center"> -->
		<v-row class="mx-auto">
			<v-col cols="12">
				<v-card v-if="showRecuperarSenha" class="mx-auto py-4" max-width="400" :loading="loading">
					<v-img src="@/assets/escudo.png" height="200" width="200" class="mx-auto align-center mt-4"></v-img>
					<v-card-title class="justify-center">Recuperar senha</v-card-title>
					<v-card-text class="text-center">
						<h4>Informe seu email de acesso para recuperar a senha.</h4>
						<h4>Um email será enviado para o endereço informado.</h4>
						<br />
						<v-text-field dense label="Email" v-model="user.emailSenha" outlined></v-text-field>
					</v-card-text>
					<v-card-actions >
						<v-spacer></v-spacer>
						<v-btn color="primary" @click="enviar" small>Enviar</v-btn>
						<v-btn color="primary" @click="close" small>Fechar</v-btn>
					</v-card-actions>
				</v-card>

				<v-card v-else class="mx-auto" max-width="400" :loading="loading">
					<v-img src="@/assets/escudo.png" height="200" width="200" class="mx-auto align-center mt-4"></v-img>
					<v-card-title class="justify-center">Login</v-card-title>
					<v-card-text class="text-center">
						<v-text-field dense label="Email" class="emailInput" v-model="user.email" type="text" outlined></v-text-field>
						<v-text-field dense label="Senha" class="senhaInput" v-model="user.password" @keydown.enter="login" type="password" outlined></v-text-field>
						<v-btn color="primary" @click="login" small>Entrar</v-btn>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="primary" small text @click="recuperarSenha">Esqueci minha senha</v-btn>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { baseApiUrl, showError, showSuccess, userKey } from '@/config/global'
import axios from 'axios'
import { mapState } from 'vuex'
//import Modal from '@/components/geral/Modal'
	
	export default{
		name: 'Auth',
		//components:{Modal},
		computed:{
			... mapState(['buscandoDados'])
		},
		data(){
			return{
				user: {email: '', password: ''},
				showModalRecuperarSenha: false,
				loading: false,
				showRecuperarSenha: false
			}
		},

		methods: {
			login(){
				//this.$store.commit('alteraBuscandoDados', true)
				this.loading = true
				const url = `${baseApiUrl}/usuarios/login.php` 
				
				axios.post(url, this.user)
					.then(res => {
						
						if(res.data.codigo == '01'){
							res.data.dados.dtNascimento = this.converterData(res.data.dados.dtNascimento)
							if(res.data.dados.hrNascimento != null){
								res.data.dados.hrNascimento = this.converterHora(res.data.dados.hrNascimento)
							}
							res.data.dados.dtIniciacao = this.converterData(res.data.dados.dtIniciacao)
							
							this.buscarDados()
							this.$store.commit('setUser', res.data)
							
							sessionStorage.setItem(userKey, JSON.stringify(res.data))
							// this.$store.commit('alteraBuscandoDados', false)
							this.$router.push({name: 'home', params:{ abreAvisos: true }})
							this.loading = false
							
						}else{
							showError(res.data.mensagem)
							//this.$store.commit('alteraBuscandoDados', false)
							this.loading = false
						}
					})
					.catch({showError})
			},

			converterHora(hr){
				
				 let data = new Date().toISOString().substr(0,10)
				 const [year, month, day] = data.split('-')
				 data = new Date(year, month-1, day, hr.substr(0,2), hr.substr(3,2))

				 return data
			},

			buscarDados(){
				
				axios.all([

					axios.get(`${baseApiUrl}/Cadastros/clas/readAll.php`),
					axios.get(`${baseApiUrl}/Cadastros/status/read.php`),
					axios.get(`${baseApiUrl}/Acessos/read.php`),
					axios.get(`${baseApiUrl}/Cadastros/pais/read.php`),
					axios.get(`${baseApiUrl}/Cadastros/locais/read.php`),
					
					
					]).then(axios.spread((clasRes, statusRes, perfisRes, paisesRes, locaisRes) => {

							if(clasRes.data.codigo == "01"){
								this.$store.commit('setClas', clasRes.data.dados)
							}

							if(statusRes.data.codigo == "01"){
								this.$store.commit('setStatus', statusRes.data.dados)
							}

							if(perfisRes.data.codigo == "01"){
								perfisRes.data.dados.forEach((item, index) => {
									item.ativo = item.ativo == "1" ? true : false
								})
								this.$store.commit('setPerfis', perfisRes.data.dados)
								
							}

							if(paisesRes.data.codigo == "01"){
								this.$store.commit('setPaises', paisesRes.data.dados)
							}

							if(locaisRes.data.codigo == "01"){
								this.$store.commit('setLocais', locaisRes.data.dados)
							}

							// if(locaisRes.data.codigo == "01"){
							// 	this.$store.commit('setLocais', locaisRes.data.dados)
							// }

							// if(locaisRes.data.codigo == "01"){
							// 	this.$store.commit('setLocais', locaisRes.data.dados)
							// }
					}))
			},

			converterData(dt){
				let data = new Date(dt)
				let difHorario = data.getTimezoneOffset() / 60
				data = new Date(data.setHours(data.getHours() + difHorario))
				
				return data
			},

			recuperarSenha(){
				this.showRecuperarSenha = true
			},

			close(){
				this.showRecuperarSenha = false
			},
			enviar(){
				this.loading = true
				if(this.user.emailSenha){
					const url = `${baseApiUrl}/emails/recuperarSenha.php` 

					axios.post(url, {email: this.user.emailSenha})
					.then(res => {

						if(res.data.codigo == '01'){
							showSuccess(res.data.mensagem)
							this.showModalRecuperarSenha = false
							this.loading = false
						}else{
							showError(res.data.mensagem)
							this.loading = false
						}
					})

				}else{
					showError('Informe um email para recuperar a senha.')
					this.loading = false
				}
				
			}
			
		},

		created(){
			
		}
	}


</script>

<style scoped>
.cor{
	background-color: red;
}
	.auth-content{
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.auth-content img{
		position: static;
		left: 0;
		top: 0;
	}

	.auth-modal{
		background-color: #fff;
		width: 350px;
		padding: 35px;
		box-shadow: 0 1px  5pxrgba(0,0,0,0.15);

		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.auth-title {
		font-size: 1.2rem;
		font-weight: 100;
		margin-top: 10px;
		margin-bottom: 15px;
	}

	.auth-modal{
		box-shadow: 1px 1px 16px rgba(0,0,0,0.3);
	}

	.auth-modal .emailInput, .auth-modal .senhaInput {
		border: 1px solid #bbb;
		width: 100%;
		padding: 3px 8px;
		outline: none;
		color: rgba(70,70,70,1);
	}

	.auth-modal .emailInput{
		margin-bottom: 15px;
	}

	.auth-modal .btn-logar{
		align-self: center;
		background-color: rgba(60, 15, 138, 1) !important;
		color: #fff;
		padding: 5px 15px;
	}

	.auth-modal a{
		margin-top: 35px;
	}

	.auth-modal hr{
		border: 0;
		width: 100%;
		height: 3px;
		background-image: linear-gradient(to right, rgba(120, 120, 120, 0), rgba(120, 120, 120, 0.75), rgba(120,120,120,0));
	}

	.recuperarSenha{
		font-size: 0.7rem;
		align-self: flex-end;
		cursor: pointer;
		margin-bottom: 10px;
	}
</style>